import { version } from "../../package.json";

export default {
	APP_NAME: `cockpit-${version}`
};
